/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Reducer for Calls Detail
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.4.0
 */

import produce from 'immer';
import moment from 'moment';
import { Reducer } from 'redux';

import { WIZARD_STORAGE_CLEAR_STEPS } from '../../modules/wizard/wizardConstants';
import { EFormatData } from '../PageDashboard/types/widgetTypes';
import { TCallsDetailActions } from './callsDetailActions';
import { CALLS_DETAIL_SET_IS_STEP_VALID, CALLS_DETAIL_SET_PARAMS } from './callsDetailConstants';

export interface ICallsDetailState {
    accountTakenCorporate: boolean;
    accountTakenPersonal: boolean;
    basketCount: number;
    chooseAccountTakenEnabled: boolean;
    dateFrom: string;
    dateTo: string;
    formatsAvailable: string[];
    isStepValid: boolean;
    minDate: string;
    reportFormat: string;
}

export const initialCallsDetailState: ICallsDetailState = {
    accountTakenCorporate: true,
    accountTakenPersonal: false,
    basketCount: 0,
    chooseAccountTakenEnabled: false,
    dateFrom: moment().subtract(1, 'month').format(EFormatData.FullDataWithTimeZone),
    dateTo: moment().format(EFormatData.FullDataWithTimeZone),
    formatsAvailable: [],
    isStepValid: true,
    minDate: moment().subtract(6, 'months').format('YYYY'),
    reportFormat: '',
};

export const callsDetailReducer: Reducer<ICallsDetailState, TCallsDetailActions> =
    (state = initialCallsDetailState, action: TCallsDetailActions) =>
        produce(state, (draft) => {
            switch (action.type) {
                case CALLS_DETAIL_SET_IS_STEP_VALID:
                    draft.isStepValid = action.payload.isStepValid;
                    break;
                case CALLS_DETAIL_SET_PARAMS:
                    draft.accountTakenCorporate = action.payload.accountTakenCorporate ?? draft.accountTakenCorporate;
                    draft.accountTakenPersonal = action.payload.accountTakenPersonal ?? draft.accountTakenPersonal;
                    draft.basketCount = action.payload.basketCount ?? draft.basketCount;
                    draft.chooseAccountTakenEnabled
                        = action.payload.chooseAccountTakenEnabled ?? draft.chooseAccountTakenEnabled;
                    draft.dateFrom = action.payload.dateFrom ?? draft.dateFrom;
                    draft.dateTo = action.payload.dateTo ?? draft.dateTo;
                    draft.formatsAvailable = action.payload.formatsAvailable ?? draft.formatsAvailable;
                    draft.minDate = action.payload.minDate ?? draft.minDate;
                    draft.reportFormat = action.payload.reportFormat ?? draft.reportFormat;
                    break;

                case WIZARD_STORAGE_CLEAR_STEPS:
                    Object.assign(draft, initialCallsDetailState);
                    break;

                default:
                    break;

            }
        });
